//  /////////////// COPYRIGHT © 2025/2026 IROÏD/DSTRKT™ FOR TIXFORGIGS
//  ////////////////////////////////////////////// ALL RIGHTS RESERVED
//  /////// LICENSED UNDER THE IROÏD LICENSE VERSION 1.0 [THE LICENSE]
//  /////// DO NOT USE THIS FILE EXCEPT IN COMPLIANCE WITH THE LICENSE
//
//  TixforGigs™ Unified API
//
//  VERSION: 4.6
//  PACKAGE: 4.6.297-SNAPSHOT
//  CONTACT: developer@tixforgigs.com
//  CREATED: 2026-02-26T01:20:10.489677Z
//
//  /////////////////////////////////////// AUTOGENERATED. DO NOT EDIT

@file:Suppress(
  "ArrayInDataClass",
  "EnumEntryName",
  "RemoveRedundantQualifierName",
  "UnusedImport"
)

package com.tixforgigs.apax.models


        import kotlinx.serialization.*
  import kotlinx.serialization.descriptors.*
  import kotlinx.serialization.encoding.*

/**
* The model
* 
* @param isVisible Defines if the age restriction is visible
* @param minimumAge The minimum age of the customer to attend the event.
* @param permissionRequired permission required
*/
@Serializable

data class AgeRestriction (


      /* Defines if the age restriction is visible */
    @SerialName(value = "isVisible") @Required val isVisible: kotlin.Boolean,


      /* The minimum age of the customer to attend the event. */
    @SerialName(value = "minimumAge") @Required val minimumAge: kotlin.Int,


      /* permission required */
    @SerialName(value = "permissionRequired") @Required val permissionRequired: kotlin.Boolean


) {




  }

